import { useState, useRef, useEffect } from "react";

function useTimer({ endDate, currentDate }) {
  const [timeLeft, setTimeLeft] = useState({
    days: null,
    hours: null,
    minutes: null,
    seconds: null,
  });

  const timeDiff = useRef(null);

  useEffect(() => {
    timeDiff.current = endDate - currentDate;

    const intervalId = setInterval(() => {
      if (timeDiff.current < 0) {
        clearInterval(intervalId);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        const days = Math.floor(timeDiff.current / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (timeDiff.current % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (timeDiff.current % (1000 * 60 * 60)) / (1000 * 60)
        );

        const seconds = Math.floor((timeDiff.current % (1000 * 60)) / 1000);

        timeDiff.current -= 1000;
        setTimeLeft({ days, hours, minutes, seconds });
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [endDate]);

  return timeLeft;
}

export default useTimer;
